import BaseSliderBlock from "./BaseSliderBlock";
import Swiper, {Navigation, Pagination} from "swiper";
// @ts-ignore
import ImageCompare from "image-compare-viewer";

class BeforeAfterGallery extends BaseSliderBlock {

    init(): void {
        const galleryEl = this.block.querySelector(".before-after-gallery");
        const sliderEl = this.block.querySelector(".swiper");

        if (galleryEl && galleryEl.classList.contains("type-overlapping")) {
            const imgPairs = galleryEl.querySelectorAll('.image-compare');
            imgPairs.forEach((el) => {
                new ImageCompare(el, {
                    addCircle: true,
                    showLabels: true
                }).mount();
            });
        }
        else {
            if (sliderEl instanceof HTMLElement) {
                new Swiper(sliderEl, {
                    loop: true,
                    navigation: this.getDefaultNavigation(),
                    pagination: this.getDefaultPagination(),
                    modules: [Navigation, Pagination]
                });
            }
        }
    }
}

export default BeforeAfterGallery;
